<div *ngFor="let d of shareLinkData | keyvalue: originalOrder">
  <mat-form-field class="share-link">
    <input #clipboardTarget type="text" matInput placeholder="Share {{d.key}}" [value]="d.value" readonly>
  </mat-form-field>
  <button [ngxClipboard]="clipboardTarget" mat-icon-button color="primary" matTooltip="Copy {{d.key}}">
    <mat-icon>file_copy</mat-icon>
  </button>
</div>
